import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import './Services.css';

/* ─── SVG Icons ─────────────────────────────────────────── */
const BuildingIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><rect x="3" y="3" width="7" height="18" /><rect x="14" y="3" width="7" height="18" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="3" y1="15" x2="21" y2="15" /></svg>
);
const InteriorIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" /></svg>
);
const FinishingIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 9h6M9 12h6M9 15h4" /></svg>
);
const FacadeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><rect x="2" y="3" width="20" height="18" rx="1" /><line x1="2" y1="9" x2="22" y2="9" /><line x1="2" y1="15" x2="22" y2="15" /><line x1="8" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="16" y2="21" /></svg>
);
const HomeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
);
const ArrowIcon = ({ dir }) => (
    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" style={{ transform: dir === 'rtl' ? 'rotate(180deg)' : 'none' }}><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
);

const BG_IMAGES = [
    'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&q=70',
    'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=70',
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=70',
    'https://images.unsplash.com/photo-1460317442991-0ec209397118?w=600&q=70',
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=70',
];

export function Services() {
    const { t, language } = useLanguage();
    const dir = language === 'ar' ? 'rtl' : 'ltr';

    const services = [
        { icon: <FinishingIcon />, key: 'service1', filter: 'finishing' },
        { icon: <InteriorIcon />,  key: 'service2', filter: 'interior' },
        { icon: <BuildingIcon />,  key: 'service3', filter: 'construction' },
        { icon: <FacadeIcon />,    key: 'service4', filter: 'facades' },
        { icon: <HomeIcon />,      key: 'service5', filter: '' },
    ];

    return (
        <>
            <section className="srv-section" dir={dir} id="services">
                <div className="srv-container">
                    <div className="srv-header">
                        <div className="srv-label-row">
                            <span className="srv-label-text">{t('services.label')}</span>
                            <span className="srv-label-bar"></span>
                        </div>
                        <h2 className="srv-title">{t('services.title')}</h2>
                        <p className="srv-subtitle">{t('services.description')}</p>
                    </div>

                    <div className="srv-grid">
                        {services.map((srv, i) => (
                            <ServiceCard
                                key={i}
                                icon={srv.icon}
                                bgImage={BG_IMAGES[i]}
                                name={t(`services.${srv.key}.name`)}
                                desc={t(`services.${srv.key}.description`)}
                                features={[
                                    t(`services.${srv.key}.f1`),
                                    t(`services.${srv.key}.f2`),
                                    t(`services.${srv.key}.f3`),
                                ]}
                                cta={t(`services.${srv.key}.cta`)}
                                link={srv.filter ? `/portfolio?filter=${srv.filter}` : '/portfolio'}
                                dir={dir}
                            />
                        ))}

                        <div className="srv-cta-card-premium">
                            <div className="srv-cta-bg" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=70')` }}></div>
                            <div className="srv-cta-overlay"></div>
                            <div className="srv-cta-content">
                                <div className="srv-cta-icon-box">
                                    <HomeIcon />
                                </div>
                                <h3 className="srv-cta-title">{t('services.ctaCard.title')}</h3>
                                <p className="srv-cta-desc">{t('services.ctaCard.description')}</p>
                                <Link to="/request-quote" className="srv-cta-btn">
                                    {t('services.ctaCard.cta')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 2. FIXED: Slim, Horizontal White Banner (Beside Each Other) */}
            <section className="white-cta-banner-slim" dir={dir}>
                <div className="wcb-container-row">
                    <div className="wcb-text-group">
                        <h2 className="wcb-title-inline">{t('services.ctaCard.title')}</h2>
                        <p className="wcb-desc-inline">{t('services.ctaCard.description')}</p>
                    </div>
                    <div className="wcb-action-side">
                        <Link to="/request-quote" className="wcb-btn-lux">
                            {t('services.ctaCard.cta')}
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}

function ServiceCard({ icon, bgImage, name, desc, features, cta, link, dir }) {
    return (
        <div className="srv-card">
            <div className="srv-card-bg" style={{ backgroundImage: `url(${bgImage})` }} aria-hidden="true" />
            <div className="srv-card-overlay" />
            <div className="srv-icon-box">{icon}</div>
            <div className="srv-card-content" dir={dir}>
                <h3 className="srv-card-title">{name}</h3>
                <p className="srv-card-desc">{desc}</p>
                <ul className="srv-features">
                    {features.map((f, i) => (
                        <li key={i} className="srv-feature-item">
                            <span className="srv-feature-dot"></span>{f}
                        </li>
                    ))}
                </ul>
                <Link to={link} className="srv-card-btn">
                    <ArrowIcon dir={dir} /><span>{cta}</span>
                </Link>
            </div>
        </div>
    );
}
